import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ValetApi from "../api/Api";
import "./CustomerSurveyPage.css";

const INITIAL_STATE = {
    q1Response: "",
    q2Response: "",
    q3Response: "",
    q4Response: "",
    q5Response: "",
    q6Response: "",
};

const CustomerSurveyPage = () => {
    const { token } = useParams();

    const [formData, setFormData] = useState(INITIAL_STATE);
    const [surveyContext, setSurveyContext] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);

    const questions = ["Did the valet greet you in a timely manner when you arrived?", "Was the valet attendant courteous and professional when you dropped off your car?", "Was the valet attendant coureous and professional when you picked up your car?", "How would you rate your overall experience with the valet parking service?", "Was valet helpful during your visit?"];

    useEffect(() => {
        async function loadSurveyContext() {
            try {
                setLoading(true);
                setError(null);
                const res = await ValetApi.getCustomerSurveyPublic(token);
                setSurveyContext(res?.data?.surveyContext || null);
            } catch (err) {
                setError(err?.response?.data?.error?.message || err?.response?.data?.error || "Invalid or expired survey link.");
            } finally {
                setLoading(false);
            }
        }

        loadSurveyContext();
    }, [token]);

    const handleChange = (evt) => {
        const { name, value } = evt.target;
        setFormData((f) => ({ ...f, [name]: value }));
    };

    const handleSubmit = async (evt) => {
        evt.preventDefault();

        try {
            setError(null);
            await ValetApi.submitCustomerSurveyPublic(token, formData);
            setSubmitted(true);
        } catch (err) {
            setError(err?.response?.data?.error?.message || err?.response?.data?.error || "Could not submit survey.");
        }
    };

    if (loading) return <div className="container mt-4 customer-survey-page">Loading survey...</div>;
    if (submitted)
        return (
            <div className="container mt-4 customer-survey-page">
                <h3>Thank you for your feedback.</h3>
            </div>
        );
    if (error) return <div className="container mt-4 text-danger customer-survey-page">{error}</div>;

    return (
        <div
            className="container mt-4 customer-survey-page"
            style={{ maxWidth: "700px" }}>
            <h2>Customer Survey</h2>
            {surveyContext && (
                <p>
                    Ticket #{surveyContext.ticketNum} - {surveyContext.locationName} / {surveyContext.podiumName}
                </p>
            )}

            <form
                className="customer-survey-form-card"
                onSubmit={handleSubmit}>
                {questions.map((q, index) => (
                    <div
                        className="mb-3"
                        key={index}>
                        <label
                            htmlFor={`q${index + 1}Response`}
                            className="form-label">
                            {q} <br />
                        </label>
                        <select
                            id={`q${index + 1}Response`}
                            name={`q${index + 1}Response`}
                            className="form-control"
                            value={formData[`q${index + 1}Response`]}
                            onChange={handleChange}
                            required>
                            <option value="">Select</option>
                            <option value="5">5 - Excellent</option>
                            <option value="4">4 </option>
                            <option value="3">3 </option>
                            <option value="2">2 </option>
                            <option value="1">1 </option>
                        </select>
                    </div>
                ))}

                <div className="mb-3">
                    <label
                        htmlFor="q6Response"
                        className="form-label">
                        Comments (optional)
                    </label>
                    <textarea
                        id="q6Response"
                        name="q6Response"
                        className="form-control"
                        rows="4"
                        value={formData.q6Response}
                        onChange={handleChange}
                    />
                </div>

                <button
                    type="submit"
                    className="btn btn-primary">
                    Submit Survey
                </button>
            </form>
        </div>
    );
};

export default CustomerSurveyPage;
